import React from 'react';
import { HashRouter, Navigate, Route, Routes } from 'react-router-dom';
import { ErrorBoundary } from './components/ErrorBoundary';
import { Layout } from './components/Layout';
import { Booking } from './pages/Booking';
import { Contact } from './pages/Contact';
import { Gallery } from './pages/Gallery';
import { Home } from './pages/Home';
import { Pricing } from './pages/Pricing';
import { ProductDetail } from './pages/ProductDetail';
import { Products } from './pages/Products';
import { PrivacyPolicy } from './pages/PrivacyPolicy';
import { Terms } from './pages/Terms';
import { AdminDashboard } from './pages/admin/AdminDashboard';
import { AdminLogin } from './pages/admin/AdminLogin';
export function App() {
  return <HashRouter data-id="element-0" data-mp="2wj8cxn0bok3n">
      <ErrorBoundary data-id="element-1" data-mp="2wifc12o1ootf">
        <Routes data-id="element-2" data-mp="2wi5nljineppu">
          <Route path="/" element={<Layout data-id="element-4" data-mp="28tmej1rry8wp" />} data-id="element-3" data-mp="28u5x8kp911bs">
            <Route index element={<Home data-id="element-6" data-mp="28sb9yzqi8x4j" />} data-id="element-5" data-mp="28sutulzptvl7" />
            <Route path="ponuda" element={<Products data-id="element-8" data-mp="23w4c7u89irxo" />} data-id="element-7" data-mp="23vcmh01cjofb" />
            <Route path="proizvod/:id" element={<ProductDetail data-id="element-10" data-mp="3ijxnsm94vshs" />} data-id="element-9" data-mp="23ut97wmn5o7m" />
            <Route path="cjenik" element={<Pricing data-id="element-12" data-mp="3ijfthv617oci" />} data-id="element-11" data-mp="3ikqwvtvkeu33" />
            <Route path="galerija" element={<Gallery data-id="element-14" data-mp="3ml17xky7saot" />} data-id="element-13" data-mp="3ii4qvyobommz" />
            <Route path="rezervacija" element={<Booking data-id="element-16" data-mp="3mj6ipufwtwex" />} data-id="element-15" data-mp="3mk84asujy1aw" />
            <Route path="kontakt" element={<Contact data-id="element-18" data-mp="3rdki07xp0nov" />} data-id="element-17" data-mp="3rcj2nr9n9f1c" />
            <Route path="uvjeti" element={<Terms data-id="element-20" data-mp="5yh2n2cyzbp" />} data-id="element-19" data-mp="3rd189ei755lx" />
            <Route path="politika-privatnosti" element={<PrivacyPolicy data-id="element-22" data-mp="56qjqnmbrsa" />} data-id="element-21" data-mp="680tswt8a8y" />
          </Route>
          <Route path="/admin" element={<AdminLogin data-id="element-24" data-mp="2zmem63p09c5e" />} data-id="element-23" data-mp="2zllijblcf2rh" />
          <Route path="/admin/dashboard" element={<AdminDashboard data-id="element-26" data-mp="33m5eibu6k0c1" />} data-id="element-25" data-mp="2zn66ujh2dpgw" />
          <Route path="*" element={<Navigate to="/" replace data-id="element-28" data-mp="33orki71fa7s5" />} data-id="element-27" data-mp="33n6zb810016y" />
        </Routes>
      </ErrorBoundary>
    </HashRouter>;
}